import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { PersonNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addPerson = (state: SyfoAppState, action: PayloadAction<PersonNode>) => {
  if (state.currentVault) {
    state.currentVault.data.people.push(action.payload);
  }
};

export const updatePerson = (state: SyfoAppState, action: PayloadAction<{ id: string; person: Partial<PersonNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.people, action.payload.id, action.payload.person);
  }
};

export const removePerson = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.people = state.currentVault.data.people.filter(p => p.id !== action.payload);
  }
};